import {
  Box,
  Heading,
  Divider,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Avatar,
  Center,
  TableContainer,
  useColorModeValue,
  Text,
  Spinner,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  useDisclosure,
  useToast,
  Flex,
  Select,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar/Navbar";
import AdminChangePasswordModal from "./AdminChangePasswordModal";
import * as mod from "../../url";

const SIDEBAR_WIDTH = "250px";

const Profile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isPassOpen,
    onOpen: onPassOpen,
    onClose: onPassClose
  } = useDisclosure();
  const toast = useToast();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [saving, setSaving] = useState(false);
  const bgColor = useColorModeValue("white", "gray.800");

  const token = localStorage.getItem("token");

  const handleAddUser = async () => {
    if (!name || !mobile || !password) {
      toast({
        title: "All fields are required",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!token) {
      toast({
        title: "Session expired. Please login again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setSaving(true);

      const response = await axios.post(
        `${mod.api_url}/users/add`,
        {
          username: name,
          mobile,
          password,
          role,
          email,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      toast({
        title: response.data.message || "User added successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setName("");
      setMobile("");
      setEmail("");
      setRole("");
      setPassword("");
      onClose();
    } catch (error) {
      console.log(error.response);

      toast({
        title: "Error adding user",
        description:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      if (!token) {
        setError("No token found. Please login again.");
        setLoading(false);
        return;
      }

      try {
        const { data } = await axios.get(`${mod.api_url}/users/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setUserData(data.user);
      } catch (err) {
        console.error("API Error:", err.response || err.message);
        setError(err.response?.data?.message || "Failed to fetch user data");
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [token]);

  if (loading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" color="teal.500" />
      </Center>
    );
  }

  if (error) {
    return (
      <Center h="100vh">
        <Text color="red.500">{error}</Text>
      </Center>
    );
  }

  if (!userData) {
    return (
      <Center h="100vh">
        <Text>No user data found.</Text>
      </Center>
    );
  }

  const { username, companyName } = userData;

  return (
    <>
      <Navbar />
      <Sidebar />

      <Box
        mt={{ base: "70px", md: "100px" }}
        ml={{ base: 0, md: SIDEBAR_WIDTH }}
        px={{ base: 4, md: 8 }}
        py={6}
        minH="100vh"
        bgGradient="linear(to-r, gray.50, gray.100)"
      >
        <Box
          maxW="100%"
          mx="auto"
          p={6}
          borderRadius="2xl"
          bg={bgColor}
          boxShadow="2xl"
        >
          <Flex justify="space-between" align="center" mb={4}>
            <Heading color="teal.600">My Profile</Heading>

            <Flex gap={2}>
              <Button colorScheme="blue" variant="outline" onClick={onPassOpen}>
                Change Password
              </Button>
              <Button colorScheme="teal" onClick={onOpen}>
                Add User
              </Button>
            </Flex>
          </Flex>

          <Divider mb={6} borderColor="teal.300" />

          <TableContainer>
            <Table variant="striped" colorScheme="teal">
              <Thead>
                <Tr>
                  <Th bg="teal.700" color="white">
                    Label
                  </Th>
                  <Th bg="teal.700" color="white">
                    Details
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                <Tr>
                  <Td fontWeight="bold">Profile</Td>
                  <Td>
                    <Center>
                      <Avatar size="xl" name={username} />
                    </Center>
                  </Td>
                </Tr>

                <Tr>
                  <Td fontWeight="bold">Company</Td>
                  <Td>{companyName || "N/A"}</Td>
                </Tr>

                <Tr>
                  <Td fontWeight="bold">Email</Td>
                  <Td>{userData?.email}</Td>
                </Tr>

                <Tr>
                  <Td fontWeight="bold">Name</Td>
                  <Td>{username}</Td>
                </Tr>

                <Tr>
                  <Td fontWeight="bold">Role</Td>
                  <Td>{userData?.role}</Td>
                </Tr>
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add New User</ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            <FormControl mb={3}>
              <FormLabel>Name</FormLabel>
              <Input
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FormControl>
            <FormControl mb={3}>
              <FormLabel>Email</FormLabel>
              <Input
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormControl>

            <FormControl mb={3}>
              <FormLabel>Mobile</FormLabel>
              <Input
                placeholder="Enter mobile"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </FormControl>
            <FormControl mb={3} isRequired>
              <FormLabel>Role</FormLabel>
              <Select value={role} onChange={(e) => setRole(e.target.value)}>
                <option value="">Select Role</option>
                <option value="player">Player</option>
                {/* <option value="agent">Agent</option> */}
                <option value="admin">Admin</option>
                <option value="super-admin">Super Admin</option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel>Password</FormLabel>
              <Input
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="teal"
              onClick={handleAddUser}
              isLoading={saving}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <AdminChangePasswordModal
        isOpen={isPassOpen}
        onClose={onPassClose}
        hasPassword={userData?.hasPassword !== false}
      />
    </>
  );
};

export default Profile;
